
/**
 * @typedef {Object} IFreemium
 * @property {boolean} isEnabled
 * @property {Object} features
 * @property {number} features.maxVolumeDiscounts
 * @property {boolean} features.isAllProductsAvailable
 * @property {number} features.maxSpecificProducts
 */

/**
 * @typedef {Object} IConfiguration
 * @property {string} namespace
 * @property {string} widgetConsoleName
 * @property {boolean} isHowToUseHidden
 * @property {boolean} isPlanUpgradeDisabled
 * @property {boolean} isTrialDurationHidden
 * @property {IFreemium} freemium
 */

/**
 * @returns {IConfiguration}
 */
export function getConfiguration() {
  return {
    namespace: '@multiorders-solutions/mo-discount-upseller-v1',
    widgetConsoleName: 'VolumeDiscount',
    isHowToUseHidden: false,
    isPlanUpgradeDisabled: false,
    isTrialDurationHidden: true,
    freemium: {
      isEnabled: true,
      features: {
        maxVolumeDiscounts: 1,
        isAllProductsAvailable: false,
        maxSpecificProducts: 5,
      }
    },
  };
}
